export default __webpack_public_path__ + "static/beard-and-bowler-logo-4c06456317ff4e8e521d8a6d8283e384.webp";